<template>
<div class="chapter">
<div class="inner_page">
      ﻿




<title>Eddies Bastard</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="application/xhtml+xml; charset=utf-8" http-equiv="Content-Type"/>
<div class="centerImage0"><svg:svg height="100%" viewbox="0 0 1200 1600" width="100%"><svg:image height="1600" transform="translate(0 0)" width="1200" xlink:href="Images/Cover.jpg"></svg:image></svg:svg></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eddiesbastard_cov.vue?73b24e12